module.exports = __webpack_public_path__ + "img/walletBox34.a2db2e86.png";